import React, { Component } from 'react';
import { connect } from 'react-redux';

class Size extends Component {
  constructor(props) {
    super(props);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      name: '',
      // eslint-disable-next-line react/no-unused-state
      number: '',
    };
  }

  handleTextChange(value) {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ name: value });
    this.props.updateCustomizations({ name: value },
      this.props.index,
      this.props.productID,
      this.props.groupID,
      this.props.choicesID);
  }

  handleNumberChange(value) {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ number: value });
    if (value > 99) {
      // eslint-disable-next-line no-param-reassign
      value = 99;
    }
    this.props.updateCustomizations({ number: value },
      this.props.index, this.props.productID,
      this.props.groupID,
      this.props.choicesID);
  }

  render() {
    return (
      <div className={`choiceElement ${this.props.productType}`}>
        {this.props.customizationsAvailable
          .filter(ca => ca.type === 'name')
          .map((name, i) => {
            const id = Math.random + i;
            return (
             <input
               key={id}
               onChange={e => this.handleTextChange(e.target.value, this.props.data.index)}
               className="nameCostumization"
               placeholder='"Ronaldo"'
               maxLength="10"
               value={this.props.customizationItems.filter(
                item => item.choicesID === this.props.choicesID &&
                item.groupID === this.props.groupID &&
                item.productID === this.props.productID &&
                item.index === this.props.index,
            ).map(el => el.value.name || '')}
             />);
             })}

        {this.props.customizationsAvailable
          .filter(ca => ca.type === 'number')
          .map((name, i) => {
            const id = Math.random + i;
          return (<input
            key={id}
            onChange={e => this.handleNumberChange(e.target.value, this.props.data.index)}
            className="numberCustomization"
            placeholder="7"
            type="number"
            max="99"
            pattern="[0-9]*"
            value={this.props.customizationItems.filter(
                item => item.choicesID === this.props.choicesID &&
                item.groupID === this.props.groupID &&
                item.productID === this.props.productID &&
                item.index === this.props.index,
            ).map(el => el.value.number || '')}
          />);
            })}

        <div className="sizeName">
          <span>{this.props.data.name}</span>
        </div>
      </div>
    );
  }
}
const mapDispatch = dispatch => (
  {
    updateCustomizations: (value, index, productID, groupID, choicesID) => dispatch({
      type: 'UPDATE_CUSTOMIZATIONS',
      value,
      index,
      productID,
      groupID,
      choicesID,
    }),
  }
);

const mapState = state => (
  {
    customizationItems: state.customizationItems,
  }
);

export default connect(mapState, mapDispatch)(Size);
